import { createAction } from "@reduxjs/toolkit";

export const resetFilings = createAction(
    "filings/resetFilings"
);